<template>
    <div class="update-user-profile col-centered">
        <form @submit.prevent="submitForm" method="PUT" accept-charset="UTF-8" novalidate="novalidate">
            <legend>User Profile</legend>

            <div class="row">
                <div class="col-sm-6 form-group has-feedback" :class="{'has-error': errors.has('firstName')}">
                    <label for="first-name">First Name</label>
                    <input id="first-name" type="text" placeholder="First Name" class="form-control" v-model="userInfo.firstName" required />
                    <span v-show="errors.has('firstName')" class="help-block">
                        {{ errors.first("firstName") }}
                    </span>
                </div>
                <div class="col-sm-6 form-group has-feedback" :class="{'has-error': errors.has('lastName')}">
                    <label for="last-name">Last Name</label>
                    <input id="last-name" type="text" placeholder="Last Name" class="form-control" v-model="userInfo.lastName" required />
                    <span v-show="errors.has('lastName')" class="help-block">
                        {{ errors.first("lastName") }}
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6 form-group has-feedback" :class="{'has-error': errors.has('email')}">
                    <label for="email">Email</label>
                    <input id="email" type="email" placeholder="Email" class="form-control" v-model="userInfo.email" required />
                    <span v-show="errors.has('email')" class="help-block">
                        {{ errors.first("email") }}
                    </span>
                </div>

                <div class="col-sm-6 form-group has-feedback" :class="{'has-error': errors.has('phone')}">
                    <label for="phone">Phone</label>
                    <input id="phone" type="number" placeholder="Phone" class="form-control" v-model="userInfo.phone" required />
                    <span v-show="errors.has('phone')" class="help-block">
                        {{ errors.first("phone") }}
                    </span>
                </div>
            </div>

            <div class="margin-md-top">
                <h5>Receive amenity related notifications from Onboard:</h5>
                <div class="form-group has-feedback margin-md-top margin-md-bottom">
                    <div>
                        <input type="checkbox" name="emailCheckValue" :checked="emailCheckValue" @change="emailCheckValue = !emailCheckValue" />
                        <label class="small"> Email Notifications</label>
                    </div>

<!--                    <input :disabled="optInStatusPending" type="checkbox" name="smsCheckValue" :checked="smsCheckValue" @change="smsCheckValue = !smsCheckValue" />-->
<!--                    <label class="small" :style="optInStatusPending ? 'color: gray' : 'color: black'"> SMS Notifications</label>-->

<!--                    <div v-if="optInStatusPending" class="margin-sm-top">-->
<!--                        <p class="small">Complete subscription to SMS notifications from the text we sent. Reply "STOP" to opt out.</p>-->
<!--                        <button class="btn btn-default" @click="resendSmsOptIn" type="submit" :disabled="isLoading">-->
<!--                            Resend SMS Confirmation-->
<!--                        </button>-->
<!--                    </div>-->
<!--                    <div v-else-if="!optInStatusConfirmed">-->
<!--                        <p v-if="smsCheckValue" style="font-size: small; margin-top: 5px">-->
<!--                            By providing your number and checking the box above, you consent to receive automated text-->
<!--                            messages from Onboard in connection with the services and amenities at {{ projectName }},-->
<!--                            even if your name appears on the do not call list. Message and data rates may apply.-->
<!--                        </p>-->
<!--                    </div>-->
                </div>
            </div>
            <hr />

            <div class="row">
                <div class="col-sm-7">
                    <button class="btn" type="submit" :disabled="isLoading" :style="{backgroundColor: marketingPrimary, color: 'white'}">
                        Update Profile
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Vue from "vue";
import VueToastComponent from "./VueToast";

const OPT_IN_STATUS_PENDING = 0;
const OPT_IN_STATUS_SUBSCRIBED = 1;
const OPT_IN_STATUS_DECLINED = 2;

export default {
    props: {
        user: {
            required: true,
            type: Object,
        },
        optInSmsStatus: {
            required: false,
            type: Number,
        },
        canSendEmail: {
            required: false,
            type: String,
        },
        marketingPrimary: {
            required: true,
            type: String,
        },
        pinpointId: {
            required: true,
            type: String,
        },
        projectName: {
            required: true,
            type: String,
        }
    },
    data() {
        return {
            isLoading: false,
            userInfo: {
                firstName: this.user.first_name,
                lastName: this.user.last_name,
                email: this.user.email,
                phone: this.user.phone,
            },
            emailCheckValue: this.canSendEmail,
            smsCheckValue: this.optInSmsStatus === OPT_IN_STATUS_PENDING || this.optInSmsStatus === OPT_IN_STATUS_SUBSCRIBED,
            toastContent: {
                component: VueToastComponent,
                props: {
                    content: "",
                },
            },
        };
    },
    computed: {
        optInStatusPending() {
            return this.optInSmsStatus === OPT_IN_STATUS_PENDING;
        },
        optInStatusConfirmed() {
            return this.optInSmsStatus === OPT_IN_STATUS_SUBSCRIBED;
        }
    },
    methods: {
        resendSmsOptIn() {
            this.isLoading = true;
            this.errors.clear();
            return this.$validator.validateAll().then((valid) => {
                if (valid) {
                    return axios
                        .put("/users/" + this.user.id + "/sendOptInSms", {
                            pinpointId: this.pinpointId,
                            userId: this.user.id,
                        })
                        .then((response) => {
                            if (response.data.errors) {
                                for (const [key, value] of Object.entries(response.data.errors)) {
                                    this.errors.add({
                                        field: key,
                                        msg: value[0],
                                    });
                                }
                            }
                            else {
                                if (response.data.message) {
                                    this.toastContent.props.content = response.data.message;
                                    this.$toast(this.toastContent, {position: "top-left", toastClassName: "vue-toast", timeout: 2000});
                                }
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            this.toastContent.props.content = "There was an issue, please try again or contact customer support";
                            this.$toast(this.toastContent, {position: "top-left", toastClassName: "vue-toast", timeout: 2000});
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            });
        },

        submitForm() {
            this.isLoading = true;
            this.errors.clear();
            return this.$validator.validateAll().then((valid) => {
                if (valid) {
                    return axios
                        .put("/users/" + this.user.id, {
                            firstName: this.userInfo.firstName,
                            lastName: this.userInfo.lastName,
                            email: this.userInfo.email,
                            phone: this.userInfo.phone,
                            canSendSms: this.smsCheckValue,
                            canSendEmail: this.emailCheckValue,
                            pinpointId: this.pinpointId,
                        })
                        .then((response) => {
                            if (response.data.errors) {
                                for (const [key, value] of Object.entries(response.data.errors)) {
                                    this.errors.add({
                                        field: key,
                                        msg: value[0],
                                    });
                                }
                                this.isLoading = false;
                            }
                            else {
                                if (response.data.message) {
                                    this.toastContent.props.content = response.data.message;
                                    this.$toast(this.toastContent, {position: "top-left", toastClassName: "vue-toast", timeout: 2000});
                                    this.isLoading = false;
                                }
                                else if (response.data.successful) {
                                    this.toastContent.props.content = response.data.successful;
                                    this.$toast(this.toastContent, {position: "top-left", toastClassName: "vue-toast", timeout: 4000});
                                    setTimeout(() => {
                                        window.location.href = "/profile";
                                    }, 2000);
                                }
                                else {
                                    this.isLoading = false;
                                }
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            this.toastContent.props.content = "There was an issue, please try again or contact customer support";
                            this.$toast(this.toastContent, {position: "top-left", toastClassName: "vue-toast", timeout: 2000});
                            this.isLoading = false;
                        });
                }
            });
        },
    },
};
</script>
